import React, { useEffect } from "react"
import { Link } from "gatsby"
import { I18nextProvider } from 'react-i18next';
import i18n from '../i18n';
import { useTranslation } from 'react-i18next';

function setLanguageStyle(lang) {
  const rootElement = document.documentElement;
  const styles = getComputedStyle(rootElement);
  let newBodyFont, newHeadFont;
  if (lang === "en") {
    newBodyFont = styles.getPropertyValue('--fontFamily-serif');
    newHeadFont = styles.getPropertyValue('--fontFamily-sans');
  } else if (lang === "ja") {
    newBodyFont = styles.getPropertyValue('--fontFamily-ja');
    newHeadFont = styles.getPropertyValue('--fontFamily-ja');
  } else {
    return;
  }
  rootElement.style.setProperty('--font-body', newBodyFont);
  rootElement.style.setProperty('--font-heading', newHeadFont);
}

const Layout = ({ navLink, location, title, children }) => {
  const { i18n } = useTranslation();

  useEffect(() => {
    setLanguageStyle(i18n.language);
  }, [i18n.language])

  const isJaRoot = path => path === `${rootPath}ja/` || path === `${rootPath}ja`

  const rootPath = `${__PATH_PREFIX__}/`
  const isRootPath = location.pathname === rootPath || isJaRoot(location.pathname)

  let header

  if (isRootPath) {
    header = (
      <h1 className="main-heading">
        <Link to={"/" + (i18n.language === "ja" ? "ja" : "")}>{title}</Link>
      </h1>
    )
  } else {
    header = (
      <Link className="header-link-home" to={"/" + (i18n.language === "ja" ? "ja" : "")}>
        {title}
      </Link>
    )
  }

  return (
    <div className="global-wrapper" data-is-root-path={isRootPath}>
      <div style={{display: 'flex', justifyContent: 'space-between'}}>
        <header className="global-header">{header}</header>
        {navLink && <nav>
          <Link to="/" className={'lang-nav' + (location.pathname === '/' ? '-disabled' : '')}>English</Link>
          {' '}/{' '}
          <Link to="/ja" className={'lang-nav' + (isJaRoot(location.pathname) ? '-disabled' : '')}>日本語</Link>
        </nav>}
      </div>
      <main>{children}</main>
      {isRootPath && <footer>
        <nav>
          <ul style={{display:'inline'}}>
            <li style={{display:'inline'}}>
            <a href={`https://twitter.com/takkyuO2`}>
              twitter
            </a>
            </li>
            {' '}/{' '}
            <li style={{display:'inline'}}>
            <a href={`https://github.com/takkyu2`}>
              github
            </a>
            </li>
          </ul>
        </nav>
      </footer>}
    </div>
  )
}

const I18nWrapper = ({ children }) => (<I18nextProvider i18n={i18n}>{children}</I18nextProvider>);

export default function WrappedLayout(props) {
  return (
      <I18nWrapper>
        <Layout {...props}/>
      </I18nWrapper>
  );
}
